export default __webpack_public_path__ + "static/media/background-paralax-2.9d921fd0.png";